export default __webpack_public_path__ + "static/media/about_bg--mobile.dd4edc08.png";